import { ReactQueryProvider } from 'aos-singleton'
import { TaskTemplateModalProvider } from 'aos-tasks'
import { Color } from 'aos-ui-common/src/styles/Color'
import React, { FCWithChildren, PropsWithChildren } from 'react'
import styled from 'styled-components'

import { ZIndex } from '../base/Theme'
import { DropdownRootProvider } from '../form/dropdown/base/DropdownRoot'

type AppContainerProps = PropsWithChildren<{
    onTemplateSavedNavigate?: (id: number) => void
}>

export const AppContainer: FCWithChildren<AppContainerProps> = props => {
    const rootRef = React.createRef<HTMLDivElement>()
    const containerRef = React.createRef<HTMLDivElement>()
    return (
        <DropdownRootProvider
            value={{
                container: containerRef,
                dropdownRoot: rootRef,
            }}
        >
            <ReactQueryProvider>
                <TaskTemplateModalProvider onTemplateSavedNavigate={props.onTemplateSavedNavigate}>
                    <ContainerBox ref={containerRef}>
                        {props.children}
                        <DropdownRoot ref={rootRef} />
                    </ContainerBox>
                </TaskTemplateModalProvider>
            </ReactQueryProvider>
        </DropdownRootProvider>
    )
}

const ContainerBox = styled.div`
    width: 100%;
    height: 100%;
    background-color: ${Color.BackgroundCanvas};
    overflow: auto;
`

export const DropdownRoot = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: ${ZIndex.DropdownMenu};
`
